import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import type {
  TooltipContentWrapperStyledComponentProps,
  TooltipRootStyledComponentsProps,
} from './Tooltip.types';

export const StyledTooltipRoot = styled('div')<TooltipRootStyledComponentsProps>(
  () => ({
    display: 'flex',
    alignItems: 'top',
    justifyContent: 'center',
    gap: '8px',
    padding: '8px 12px',
    whiteSpace: 'pre-wrap',
    borderRadius: '4px',
    maxWidth: 'calc(100cqw - 40px)',
  }),
  getAllStyledProps,
);

export const StyledTooltipContentWrapper = styled('div')<TooltipContentWrapperStyledComponentProps>(
  ({ theme }) => ({
    ...theme.typography.caption.regular,
  }),
  getAllStyledProps,
);
